/* r277 18.10.2026 Kate «быстрые возвраты»: Clarity zeigt Produktseiten, die vom Handy 2–4,6 s laden, und Rückkehr nach 0–11 s von der Liste.
   Karten-Seiten im Hintergrund vorladen (Speculation Rules in Chrome/Edge/Samsung; <link rel=prefetch> in Firefox). Safari/iOS kann beides nicht -> dort bewusst NICHTS tun
   (ein fetch() würde nur doppelt laden). Auslöser: Finger/Maus auf der Karte, Hover > 80 ms (nur Desktop) oder Karte >= 60 % sichtbar für 700 ms. Höchstens 10 Seiten je Aufruf.
   Aus bei Datensparmodus und 2G. Nur Produktseiten derselben Domain. Abschalten: Datei-Einbindung in layout/theme.liquid entfernen. */
(function () {
  if (window.__kdPrefetch) return; window.__kdPrefetch = 1;
  var con = navigator.connection || {};
  if (con.saveData || /(^|-)2g$/.test(con.effectiveType || '')) return;
  var spec = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var l = document.createElement('link'), lin = !!(l.relList && l.relList.supports && l.relList.supports('prefetch'));
  if (!spec && !lin) return;
  var MAX = 10, n = 0, done = {};
  function prod(a) {
    if (!a || !a.getAttribute) return null;
    var h = a.getAttribute('href'); if (!h) return null;
    var u; try { u = new URL(h, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || u.pathname.indexOf('/products/') !== 0 || u.pathname === location.pathname || done[u.pathname]) return null;
    return u;
  }
  function go(a) {
    if (n >= MAX || document.hidden) return;
    var u = prod(a); if (!u) return;
    done[u.pathname] = 1; n++;
    var href = u.pathname + u.search;
    if (spec) {
      var s = document.createElement('script'); s.type = 'speculationrules';
      s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [href] }] });
      document.head.appendChild(s);
    } else {
      var k = document.createElement('link'); k.rel = 'prefetch'; k.as = 'document'; k.href = href; document.head.appendChild(k);
    }
  }
  function link(t) { return t && t.closest ? t.closest('a[href*="/products/"]') : null; }
  document.addEventListener('touchstart', function (e) { go(link(e.target)); }, { passive: true, capture: true });
  document.addEventListener('mousedown', function (e) { go(link(e.target)); }, { passive: true, capture: true });
  if (window.matchMedia && matchMedia('(hover:hover)').matches) {
    var ht;
    document.addEventListener('mouseover', function (e) { var a = link(e.target); clearTimeout(ht); if (a) ht = setTimeout(function () { go(a); }, 80); }, { passive: true });
  }
  if ('IntersectionObserver' in window) {
    var timers = new WeakMap();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var a = en.target;
        if (en.isIntersecting) { timers.set(a, setTimeout(function () { go(a); io.unobserve(a); }, 700)); }
        else { clearTimeout(timers.get(a)); }
      });
    }, { threshold: 0.6 });
    function scan(root) { (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) { if (!a.__kdpf && prod(a)) { a.__kdpf = 1; io.observe(a); } }); }
    var start = function () { scan(); new MutationObserver(function () { clearTimeout(scan.t); scan.t = setTimeout(scan, 300); }).observe(document.body, { childList: true, subtree: true }); };
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 }); else setTimeout(start, 1500);
  }
  /* r283 18.10. Kate «Möbel-Knopf im Hero lädt zu lange»: Ziel des Hero-Knopfs (/collections/…, 770 KB HTML) schon im Hintergrund laden, solange der Film läuft; zusätzlich bei Berührung/Maus auf den Knopf. Gleiche Regeln (Datensparmodus/2G aus, Safari/iOS kann es nicht). */
  (function () {
    var a = document.querySelector('.kd-cta a[href^="/collections/"]'); if (!a) return;
    var href = a.getAttribute('href'), did = 0;
    function pf() {
      if (did || document.hidden) return; did = 1;
      if (spec) { var s = document.createElement('script'); s.type = 'speculationrules'; s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [href] }] }); document.head.appendChild(s); }
      else { var k = document.createElement('link'); k.rel = 'prefetch'; k.as = 'document'; k.href = href; document.head.appendChild(k); }
    }
    a.addEventListener('touchstart', pf, { passive: true }); a.addEventListener('mouseenter', pf, { passive: true });
    setTimeout(pf, 2500);
  })();
})();
